import React from 'react';
import { SwitcherThemedItemWithEvents } from '../../ui/primitives';
import { type SwitcherItemType } from '../../common/utils/links';
import { getItemAnalyticsContext, NavigationAnalyticsContext } from '../../common/utils/analytics';
import { AnalyticsItemType } from '../../types';
import { AppIcon } from '../../ui/primitives/app-icon';

interface AdminSubsectionProps {
	adminLinks: SwitcherItemType[];
}

export const AdminSubsection = ({ adminLinks }: AdminSubsectionProps) => {
	return (
		<React.Fragment>
			{adminLinks.map((item, groupIndex) => (
				<NavigationAnalyticsContext
					key={item.key}
					data={getItemAnalyticsContext(groupIndex, item.key, AnalyticsItemType.ADMIN)}
				>
					<SwitcherThemedItemWithEvents
						tag="li"
						icon={<AppIcon iconKey={item.iconKey} testId="switcher-item-icon__admin" />}
						href={item.href}
						testId={`switcher-item__${item.key}`}
					>
						{item.label}
					</SwitcherThemedItemWithEvents>
				</NavigationAnalyticsContext>
			))}
		</React.Fragment>
	);
};
